import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_right.png";
import { StaticImage } from "gatsby-plugin-image";

const Targetcmore = () => {
  return (
    <div
      className="target_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={7}
            xl={7}
            xxl={7}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/cmore/audience.png"
              alt="TekRevol"
              className="img-fluid d-none d-md-block"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={951}
            />
            <StaticImage
              src="../../../images/case-studies/cmore/aud_mob.png"
              alt="TekRevol"
              className="img-fluid d-sm-block d-md-none"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={951}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="my-auto offset-xl-1"
          >
            <h2>
              Target <span>Audience</span>
            </h2>
            <p>
              The target audience for the e-commerce platform includes
              construction material stores and builders, aiming to streamline
              their procurement processes and provide a convenient and
              centralized platform for transactions.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Targetcmore;
